// extracted by mini-css-extract-plugin
export default {"about":"About_about__rLCow","wrapper":"About_wrapper__O4ao0","main":"About_main__98sL-","left":"About_left__PqipS","right":"About_right__OX9fm"};